(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-category-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('category-row')) {
    customElements.define(
      'category-row',
      class CategoryRow extends HTMLElement {
        connectedCallback() {
          this.arrows = this.querySelector('.category-products__arrows');
          this.prevButton = this.querySelector('[data-dir="-1"]');
          this.nextButton = this.querySelector('[data-dir="1"]');
          this.prevButton?.addEventListener('click', () => this.go(-1));
          this.nextButton?.addEventListener('click', () => this.go(1));

          const pending = this.querySelector('[data-recommendations-url]');
          if (pending) {
            this.loadWhenVisible(pending);
          } else {
            this.bindTrack();
          }
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.resizeObserver?.disconnect();
          cancelAnimationFrame(this.frame);
        }

        bindTrack() {
          this.track = this.querySelector('.category-products__track');
          if (!this.track) return;

          this.scheduleUpdate = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.update());
          };

          this.track.addEventListener('scroll', this.scheduleUpdate, { passive: true });
          this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
          this.resizeObserver.observe(this.track);
          this.update();
        }

        update() {
          if (!this.track || !this.arrows) return;
          const max = this.track.scrollWidth - this.track.clientWidth;
          const scrollable = max > 1;

          this.arrows.hidden = !scrollable;
          if (!scrollable) return;

          this.prevButton.disabled = this.track.scrollLeft <= 1;
          this.nextButton.disabled = this.track.scrollLeft >= max - 1;
        }

        go(direction) {
          if (!this.track) return;
          const item = this.track.querySelector('.category-products__item');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = item ? item.offsetWidth + gap : this.track.clientWidth;
          const perPage = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
          const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.track.scrollBy({ left: direction * step * perPage, behavior: smooth ? 'smooth' : 'auto' });
        }

        loadWhenVisible(pending) {
          // Рекомендации грузим, только когда ряд приближается к экрану
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              this.load(pending);
            },
            { rootMargin: '0px 0px 600px 0px' }
          );
          this.observer.observe(this);
        }

        async load(pending) {
          try {
            const response = await fetch(pending.dataset.recommendationsUrl);
            if (!response.ok) throw new Error(response.status);

            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const result = html.querySelector('[data-recommendations-result]');

            if (result && result.children.length) {
              pending.replaceWith(result);
              this.bindTrack();
            } else {
              this.hidden = true;
            }
          } catch (error) {
            this.hidden = true;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-floating-coupon"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('floating-coupon')) {
    const STORAGE_KEY = 'hram_coupon_closed';

    customElements.define(
      'floating-coupon',
      class FloatingCoupon extends HTMLElement {
        connectedCallback() {
          this.querySelector('.floating-coupon__close')?.addEventListener('click', () => this.close());

          if (window.Shopify && window.Shopify.designMode) {
            this.hidden = false;
            return;
          }

          if (this.wasClosedRecently()) return;

          this.timer = setTimeout(() => {
            this.hidden = false;
          }, Number(this.dataset.delay) || 0);
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
        }

        wasClosedRecently() {
          try {
            const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
            if (!saved || saved.v !== this.dataset.version) return false;
            const hideMs = (Number(this.dataset.hideHours) || 1) * 60 * 60 * 1000;
            return Date.now() - saved.t < hideMs;
          } catch (e) {
            return false;
          }
        }

        close() {
          this.hidden = true;
          try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify({ v: this.dataset.version, t: Date.now() }));
          } catch (e) {
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-brand"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-new"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
